import { RouteRecordRaw } from 'vue-router';
import RegistrationApprovalPage from '/@pages/RegistrationApprovalPage/RegistrationApprovalPage.vue';
import RegistrationCreatePage from '/@pages/RegistrationCreatePage/RegistrationCreatePage.vue';
import RegistrationDayPage from '/@pages/RegistrationDayPage/RegistrationDayPage.vue';
import RegistrationErrorPage from '/@pages/RegistrationErrorPage/RegistrationErrorPage.vue';
import RegistrationItemPage from '/@pages/RegistrationItemPage/RegistrationItemPage.vue';
import RegistrationWeekPage from '/@pages/RegistrationWeekPage/RegistrationWeekPage.vue';

export const timerRoutes: RouteRecordRaw[] = [
  { path: '/timer', redirect: '/timer/week' },
  { path: '/timer/', redirect: '/timer/week' },

  {
    path: '/timer/week',
    component: RegistrationWeekPage,
    meta: { gate: 'timer' },
    children: [
      {
        path: ':registrationId',
        component: RegistrationItemPage,
        meta: { isModal: true, gate: 'timer' },
      },
    ],
  },

  {
    path: '/timer/day',
    component: RegistrationDayPage,
    meta: { gate: 'timer' },
    children: [
      {
        path: ':registrationId',
        component: RegistrationItemPage,
        meta: { isModal: true, gate: 'timer' },
      },
    ],
  },

  {
    name: 'NewRegistration',
    path: '/timer/new',
    component: RegistrationCreatePage,
    meta: { gate: 'timer' },
    props: ({ query }) => ({
      projectId: query.projectId != null ? Number(query.projectId) : null,
      createCopy: query.createCopy === 'true',
      userId: query.userId,
      selectUser: query.selectUser === 'true',
    }),
  },

  {
    path: '/timer/registration',
    component: RegistrationCreatePage,
    meta: { gate: 'timer' },
  },

  {
    path: '/timer/registration/:registrationId/edit',
    component: RegistrationCreatePage,
    meta: { gate: 'timer' },
    props: ({ query }) => ({
      createCopy: query.createCopy === 'true',
    }),
  },

  {
    path: '/timer/approval',
    component: RegistrationApprovalPage,
    meta: { gate: 'timer' },
    children: [
      {
        path: ':registrationId',
        component: RegistrationItemPage,
        meta: { isModal: true, gate: 'timer' },
      },
    ],
  },

  {
    path: '/timer/admin',
    component: RegistrationErrorPage,
    meta: { gate: 'timer' },
    children: [
      {
        path: ':registrationId',
        component: RegistrationItemPage,
        meta: { isModal: true, gate: 'timer' },
      },
    ],
  },
];
